// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1tNOx","isCentered":"style_isCentered__2m0tW"};